<template>
  <q-layout view="hHh lpR fff" style="min-height: auto">
    <q-page-container class="be-desktop-container">
      <div v-if="$route.path.indexOf('integrations/') === -1" class="be-main-lr q-mt-lg">
        <div class="row" style="justify-content: space-between">
          <div class="col">
            <q-btn flat icon="app:back" class="be-btn-round be-icon-12" :to="backPath" />
          </div>
          <div class="col-auto text-right">
            <q-btn v-if="$q.platform.is.mobile" flat icon="app:close" class="be-icon-12" to="/" />
          </div>
          <q-dialog
            v-model="showDeleteOrder"
            class="be-dialog"
            :position="$q.platform.is.mobile ? 'bottom' : 'standard'"
          >
            <q-card>
              <q-btn
                flat
                icon="app:close"
                class="be-btn-round be-icon-12"
                style="position: absolute; top: 20px; right: 20px; z-index: 9000"
                @click="showDeleteOrder = false"
              />
              <q-card-section class="be-main-lr text-center q-pt-md" style="margin-top: 48px">
                <div class="be-icon-52 q-mb-lg">
                  <q-icon name="app:delete" class="be-icon-red" />
                </div>
                <div
                  class="be-title"
                  style="margin-bottom: 50px"
                  v-html="
                    cartStore.group_order_admin
                      ? $t('cart.group-order.are-you-sure-delete-order')
                      : $t('cart.group-order.are-you-sure-giveup-order')
                  "
                ></div>
                <q-btn
                  class="be-btn-l bg-negative text-white full-width"
                  :label="
                    cartStore.group_order_admin
                      ? $t('cart.group-order.delete-order')
                      : $t('cart.group-order.giveup-on-order')
                  "
                  @click="deleteGroupOrder"
                />
                <div class="text-center full-width" style="margin: 22px 0">
                  <div class="be-link" @click="showDeleteOrder = false">{{ $t('buttons.cancel') }}</div>
                </div>
              </q-card-section>
            </q-card>
          </q-dialog>
        </div>
      </div>
      <router-view class="bg-white be-main-lr" />
    </q-page-container>
  </q-layout>
</template>

<script>
import { createMetaMixin } from 'quasar'
import { mapState, mapStores } from 'pinia'
import { useSettingsStore } from 'stores/settings'
import { useCartStore } from 'stores/cart'

export default {
  name: 'LayoutCart',
  mixins: [
    createMetaMixin(function mymeta() {
      return {
        link: [
          {
            rel: 'icon',
            href: this.websiteLogo !== null ? `${this.$assetsUrl()}${this.websiteLogo}` : null
          }
        ],
        meta: {}
      }
    })
  ],
  data() {
    return {
      backPath: '/',
      showDeleteOrder: false
    }
  },
  computed: {
    ...mapState(useSettingsStore, {
      websiteLogo: store => store.website.logo
    }),
    ...mapStores(useCartStore)
  },
  watch: {
    $route() {
      if (this.$route.path === '/cart/checkout' && this.$q.platform.is.mobile) {
        this.backPath = '/cart'
      } else if (this.$route.path === '/cart/group-order-initiation') {
        this.backPath = '/cart'
      } else {
        this.backPath = '/'
      }
    }
  },
  mounted() {
    if (this.$route.path === '/cart/checkout' && this.$q.platform.is.mobile) {
      this.backPath = '/cart'
    } else if (this.$route.path === '/cart/group-order-initiation') {
      this.backPath = '/cart'
    }
  }
}
</script>
